import { ReactElement, useCallback } from 'react';

import { PromiseVoidFunction, useBoolean } from '@dreryk/react-common';

import { PatientInPersonExaminationRequiredModal } from './PatientInPersonExaminationRequiredModal';

type PatientInPersonExaminationRequiredModalOutputProps = {
   onPatientInPersonExaminationConfirmed: PromiseVoidFunction;
   visitId: number;
};

type UsePatientInPersonExaminationRequiredModalOutput = {
   openPatientInPersonExaminationRequiredModal: () => void;
   renderPatientInPersonExaminationRequiredModal: (
      props: PatientInPersonExaminationRequiredModalOutputProps
   ) => ReactElement | null;
};

export const usePatientInPersonExaminationRequiredModalOpener = (): UsePatientInPersonExaminationRequiredModalOutput => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   const handleModalOpen = useCallback(() => {
      openModal();
   }, [openModal]);

   return {
      renderPatientInPersonExaminationRequiredModal: (props) =>
         modalOpened ? (
            <PatientInPersonExaminationRequiredModal
               onClose={closeModal}
               onPatientInPersonExaminationConfirmed={props.onPatientInPersonExaminationConfirmed}
               visitId={props.visitId}
            />
         ) : null,
      openPatientInPersonExaminationRequiredModal: handleModalOpen,
   };
};
